/** Mirrors backend `demo_agency_setup.defaults` (EMR-471). */
export const DEFAULT_DEMO_FF_TEMPLATE_AGENCY = 'NewDay';

export const DEFAULT_DEMO_ADMIN_EMAILS: readonly string[] = [
  'yunus@rogerhealthcare.com',
  'matthew@rogerhealthcare.com',
  'sarah@rogerhealthcare.com',
  'arman@rogerhealthcare.com',
  'chloe@rogerhealthcare.com',
];
